module.exports = __webpack_public_path__ + "img/pattern2.c2c3542.svg";